document.querySelectorAll('.video__wrapper').forEach(wrapper => {
    wrapper.addEventListener('click', () => {
        const iframe = wrapper.dataset.iframe;
        if (!iframe) return;

        const container = wrapper.querySelector('.video__iframe-container');
        container.innerHTML = iframe;

        // Remove cover and button
        const img = wrapper.querySelector('img');
        if(img) img.remove();
        const btn = wrapper.querySelector('.video__wrapper--button');
        if(btn) btn.remove();
    });
});
